import React from "react";
import styled from "styled-components";
import { theme } from "../theme/semanticTheme";

const Wrapper = styled.div`
  margin-bottom: ${theme.spacing.xl};
`;

const Title = styled.h1`
  font-family: ${theme.typography.fontFamily};
  font-size: 28px;
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.primary};
  margin: 0 0 ${theme.spacing.xs} 0;
`;

const Subtitle = styled.p`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.fontSize.base};
  color: ${theme.colors.textMuted};
  margin: 0;
`;

/**
 * Molecule: DashboardHeader – Dashboard title + subtitle (Command Center style).
 */
export default function DashboardHeader({ title = "Dashboard", subtitle }) {
  return (
    <Wrapper>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Wrapper>
  );
}
